var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V72.5C1 72.7761 1.22386 73 1.5 73H73",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47058 56.0589L17.5559 39.8884C17.7275 39.545 18.2061 39.5152 18.4191 39.8346L25.8998 51.0556C26.12 51.386 26.6189 51.3402 26.7754 50.9752L38.754 23.025C38.9105 22.66 39.4094 22.6142 39.6296 22.9446L47.1103 34.1656C47.3233 34.485 47.8019 34.4552 47.9735 34.1118L59.8868 10.2854C60.0632 9.93249 60.5597 9.91342 60.7627 10.2517L73 30.6472",
    stroke: "#39C5CA",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.a230578eadb58c3bfa808244ee533101.svg";
export { ForwardRef as ReactComponent };